import FooterTitle from '../footerTitle';
import './styles.scss';

interface FooterSocialProps {
	data: {
		title: string;
		rows: object[];
	};
}

const FooterSocial: React.FC<FooterSocialProps> = (props: FooterSocialProps) => {
	const { data } = props;

	const renderIconRow = (rowItems: any, rowIndex: any) => (
		<div key={rowIndex} className="footerSocial__row">
			{rowItems.map((item: any, itemIndex: any) => (
				<a
					key={itemIndex}
					className="footerSocial__icon"
					rel="noopener noreferrer"
					target="_blank"
					href={item.link}
					aria-label={item.label}
					data-cy="social-icon"
				>
					<item.icon />
				</a>
			))}
		</div>
	);

	return (
		<div className="footerSocial">
			<FooterTitle title={data.title} />
			<div className="footerSocial__rows">{data.rows.map((row: any, index: any) => renderIconRow(row.row, index))}</div>
		</div>
	);
};
export default FooterSocial;
